// @ts-nocheck
/* eslint-disable no-param-reassign */
import _ from 'lodash';
import axios from 'axios';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { API_URL } from '../configs';
import { toastTypes } from '../enums';
import getRoot from './root';

const useFormsStore = create(persist((set, get) => ({
  forms: {},
  formLinks: {},
  currentUrl: undefined,
  urlsInProgress: [],
  loading: false,

  reset: () => set({ formLinks: {}, currentUrl: undefined, loading: false }),

  getFormLinks: async () => {
    set({ loading: true });
    const res = await axios.get(`${API_URL}/api/forms/get-all-forms`);
    if (res.data.success && res.data.data) {
      const root = getRoot();
      const forms = res.data.data;
      const mergedUrl = {};
      const domains = Object.keys(res.data.data);

      for (let i = 0; i < domains.length; i += 1) {
        const pathNodes = Object.values(res.data.data)[i].paths || {};
        const paths = Object.keys(pathNodes);
        for (let j = 0; j < paths.length; j += 1) {
          mergedUrl[`${domains[i]}${paths[j]}`] = res.data.data[domains[i]].paths[paths[j]];
          const emailLogicConfig = _.get(mergedUrl, `${domains[i]}${paths[j]}.emailLogic.logic`);
          if (emailLogicConfig) {
            for (let k = 0; k < emailLogicConfig.length; k += 1) {
              const { minuteDifference } = emailLogicConfig[k];
              const hourDifferenceValue = minuteDifference / 60;
              emailLogicConfig[k] = _.omit(emailLogicConfig[k], ['minuteDifference']);
              emailLogicConfig[k].hourDifference = hourDifferenceValue;
            }
          }
          const campaignIds = _.get(res, ['data', 'data', domains[i], 'paths', paths[j], 'integrations', 'OMI366', 'dripCampaigns'], []);
          if (root.integrations && root.integrations.OMI366) {
            const omi = root.integrations.OMI366;
            omi.assignedDripCampaigns = _.merge(omi.assignedDripCampaigns || {}, {
              [domains[i]]: { [paths[j]]: { campaignIds } },
            });
          }
        }
      }
      set({ forms, formLinks: mergedUrl, loading: false });
      return mergedUrl;
    }
    set({ formLinks: [], loading: false });
    return [];
  },

  removeFormLink: async (url) => {
    const root = getRoot();
    try {
      set({ loading: true });
      await axios.delete(`${API_URL}/api/forms/edit-form`, { data: { url: `https://${url}` } });
    } catch (err) {
      console.error(err);
    } finally {
      await get().getFormLinks();
      root.success('Form removed successfully.');
      set({ loading: false });
    }
  },

  addFormLink: async (url) => {
    const root = getRoot();
    try {
      set((s) => ({ loading: true, urlsInProgress: [...s.urlsInProgress, url] }));
      const res1 = await axios.post(`${API_URL}/api/forms/edit-form`, { url });
      if (!res1.data.success) throw new Error('failed to create entry');
      const res2 = await axios.post(`${API_URL}/api/analytics/create`, { urls: [url] });
      if (!res2.data.success) throw new Error('failed to create entry');
      await get().verifySnippetInstall(url);
      root.success('Your form has been added.', toastTypes.addFormLink);
      root.clearToast(toastTypes.addFormLink);
    } catch (err) {
      root.failure('Your form was not added.', toastTypes.addFormLink);
    } finally {
      set((s) => ({
        urlsInProgress: s.urlsInProgress.filter((cur) => cur !== url),
        loading: false,
      }));
    }
  },

  verifySnippetInstall: async (rawUrl) => {
    let url = rawUrl;
    set({ currentUrl: url, loading: true });
    try {
      if (url.indexOf('https://') === 0) url = url.substring(8);
      await axios.post(`${API_URL}/api/um/verify-snippet-install`, { url: [url] });
      await get().getFormLinks();
    } catch (err) {
      console.error(err);
    } finally {
      set({ loading: false, currentUrl: null });
    }
  },

  updateForm: ({ url, diff }) => {
    const root = getRoot();
    try {
      const { hostname, pathname } = url;
      const forms = _.cloneDeep(get().forms);
      const currentForm = _.get(forms, [hostname, 'paths', pathname]);
      _.set(forms, [hostname, 'paths', pathname], { ...currentForm, ...diff });
      set({ forms });
    } catch (err) {
      root.failure('Failed to update forms locally. Please refresh.');
    }
  },
}), {
  name: 'Forms',
  storage: createJSONStorage(() => localStorage),
  partialize: (s) => ({ forms: s.forms }),
}));

export default useFormsStore;
